<template>
  <div class="table-panel-containers">
    <panel-container class="condition-container" v-if="showCondition">
      <el-space style="width: auto;" wrap>
        <slot name="condition"></slot>
      </el-space>
      <div class="condition-search-container" v-if="showConditionSearch">
        <search-button
          class="condition-container-button"
          @buttonClick="conditionSearch"
          >查询</search-button
        >
      </div>
      <!-- 
        查询右侧插槽
       -->
      <el-space style="flex-wrap: wrap;
        margin-bottom: -8px;
        align-items: center;
        flex: 1;
        justify-content: space-evenly;" wrap>
        <slot name="conditionRight" :data="requestData"></slot>
      </el-space>
    </panel-container>
    
    <title-panel v-if="showTitle">
      <template #left>
        <slot name="tabelTitleLeft">
          {{ tabelTitle }}
        </slot>
      </template>
      <template #right>
        <slot name="tabelTitleRight"></slot>
      </template>
    </title-panel>
    <div
      style="width: 100%; height: 100%; position: relative; overflow: auto; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);"
      ref="tabelContainerDiv"
    >
    <!-- :header-cell-style="{ backgroundColor: 'red' }" -->
      <el-table
        ref="tabel"
        class="tabel-panel-container"
        :border="true"
        size="small"
        height="400"
        :header-cell-class-name="headerClass"
        
        :cell-class-name="cellClass"
        :data="dataSource"
		
        :highlight-current-row="true"
        @cell-dblclick="tabelCellDblClick"
        @row-dblclick="tableRowDblClick"
        @row-click="rowClick"
        @header-dragend="handleDoLayOut"
      >
        <!-- tableColumns就是传递过来得数组rowColumns -->
        <tabel-column
          v-for="(item, index) in tableColumns"
          :key="`tableColum${index}`"
          :index="index"
          :fixed="item.fixed"
          :height="item.height"
          :item="item"
          :allCheckedPop="allCheckedPop"
          @allCheckedChange="allCheckedChange"
          @checkColumnChange="checkColumnChange"
        >
          <!-- 使用插槽，接受子组件传递过来得数据--使用$data -->
          <template
            v-if="!item.groups || item.groups.length == 0"
            v-slot:[item.slot]="$data"
          >
            <!-- 再将$data.data传递给父组件，暴漏子组件中得数据 -->
            <slot :name="item.slot" :data="$data.data"> </slot>
          </template>
          <!-- <template v-if="item.groups && item.groups.length > 0" v-for="(slotName) in item.slots" v-slot:[slotName]="$data">
							<slot :name="slotName" :data="$data.data"></slot>
						</template> -->
        </tabel-column>
      </el-table>
    </div>
    <el-pagination
      background
      :pager-count="pagerCount"
      v-model:page-size="dataPagesize"
      v-model:total="rowsCount"
      v-model:current-page="currentPageSinceOne"
      :prev-text="prePageText"
      :page-sizes="[10,20,30,40,50,100]"
      :next-text="nextPageText"
      @current-change="pageChange"
      @size-change="sizeChange"
      layout="sizes,total, prev, pager, next, jumper,slot"
      style="margin-top: 20px;"
      v-if="showPagenation"
    >
      <template #default>
        <el-button size="mini" @click="refresh">刷新</el-button>
      </template>
    </el-pagination>
    <!-- 数据展现形式：message为提示信息，data为form表单 -->
    <pop-dialog
      ref="dialog"
      detailShowType="data"
      :meta="detailItems"
      v-if="showDialogValue"
      :userPassword="userPassword"
      :approve="approve"
      :popRowTemplate="popRowTemplate"
      @confirmClick="popConfirmClick"
      @dialogClose="closeDialog"
      @btnApproveClick="popApproveClick"
      @closeApproveDialog="closeApproveDialog"
    >
      <template v-slot="$dataPop">
        <slot :name="dialogSlot" :data="$dataPop"></slot>
      </template>
    </pop-dialog>
  </div>
</template>

<script>
import titlePanel from "@/components/titlePanel.vue";
import panelContainer from "@/components/panelContainer.vue";
import searchButton from "@/components/searchButton.vue";
import api from "@/api/tabel.js";
import popDialog from "@/components/popDialog.vue";
import tabelColumn from "@/components/tableColumn.vue";
import { errMsg } from "@/notify/index.js";
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  computed,
  nextTick,
  watch,
} from "vue";

export default defineComponent({
  name: "tabelPanel",
  components: {
    titlePanel,
    panelContainer,
    searchButton,
    popDialog,
    tabelColumn,
  },
  props: {
    //just for xx
    popToCustomer: {
      type: Boolean,
      default: false,
    },
    //
    showTitle: {
      type: Boolean,
      default: true,
    },
    showPagenation: {
      type: Boolean,
      default: true,
    },
    showConditionSearch: {
      type: Boolean,
      default: true,
    },
    showCondition: {
      type: Boolean,
      default: true,
    },
    autoSearch: {
      type: Boolean,
      default: false,
    },
    apiData: {
      type: Array,
      default: null,
    },
    tabelTitle: {
      type: String,
      default: "用户列表",
    },
    condition: {
      type: Object,
      default() {
        return {};
      },
    },
    api: {
      type: String,
      default: null,
    },
    pageSize: {
      type: Number,
      default: 100,
    },
    pagerCount: {
      type: Number,
      default: 7,
    },
    prePageText: {
      type: String,
      default: "上一页",
    },
    nextPageText: {
      type: String,
      default: "下一页",
    },
    skipButtonText: {
      type: String,
      default: "跳转",
    },
    editType: {
      type: String,
      default: "row", // row pop
    },
    rowTemplate: {
      type: Array,
      default() {
        return [
          {
            columnType: "", //index selection
            headerLabel: "测试",
            width: 120,
            dataIndex: "test",
          },
          {
            columnType: "", //index selection
            headerLabel: "测试1",
            width: 120,
            dataIndex: "test1",
          },
        ];
      },
    },
    clickRowSelected: {
      type: Boolean,
      default: false,
    },
    pagenationInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    autoSearchObj: {
      type: Object,
      default: null,
    },
    initDataSource: {
      type: Array,
      default: null,
    },
    fixed: {
      type: String,
      default: "false",
    },
    userPassword: {
      type: String,
      default: null,
    },
    popNeedTransform:{
      type:Boolean,
      default:false,
    }
  },
  emits: [
    "update:pagenationInfo",
    "popConfirmButtonClick",
    "tabelRowClick",
    "customerRowDblClick",
    "getReqData",
    "searchBTN"
  ],
  setup(props, { emit }) {
    onMounted(() => {
      data.dataPagesize=props.pageSize
      if (!props.showCondition || props.autoSearch) {
        methods.conditionSearch();
      }

      if (props.initDataSource) {
        console.log('props--',props.initDataSource)
        data.dataSource = props.initDataSource;
      }
      if(data.tabel){
        nextTick(()=>{
          const refTable=data.tabel
          const scrollDom=document.querySelectorAll(".el-table__body-wrapper")[0]
            //  const dom=data.table?.bodyWrappe
              console.log(data.tabel,'表格',scrollDom)
              scrollDom.addEventListener("scroll",()=>{
                methods.debounce(refTable)
                
                
              })
        })
        
      }

      nextTick(() => {
        let div = data.tabelContainerDiv;
        if (div) {
          let clientWidth = div.clientWidth;
          let clientHeight = div.clientHeight;
          let tabelDiv = data.tabel.$el;
          if (tabelDiv) {
            let divRowContainer = tabelDiv.querySelector(
              ".el-table__empty-block"
            );
            divRowContainer.style.width = `${clientWidth}px`;
            divRowContainer.style.height = `${clientHeight}px`;
            divRowContainer.style.display = "flex";
            divRowContainer.style.alignItems = "center";
            divRowContainer.style.alignContent = "center";
            divRowContainer.style.justifyContent = "center";
            divRowContainer.style.fontSize = "20px";
          }
        }
      });

      window.addEventListener("keydown", (code) => {
        if (code.keyCode == 16) {
          data.pressShiftKey = true;
        }
      });

      window.addEventListener("keyup", (code) => {
        if (code.keyCode == 16) {
          data.pressShiftKey = false;
        }
      });
    });

    let data = reactive({
      dataPagesize:20,
      debounceFlag:null,
      currentPageSinceOne:1,
      allChecked: false,
      rowsCount: 1,
      dataSource: [],
      popTitle: "新增",
      popData: null,
      allCheckedPop: false,
      dialogSlot: "",
      showDialogValue: false,
      pressShiftKey: false,
      selectFirstRowIndex: -1,
      pager: null,
      tabelContainerDiv: null,
      tabel: null,
      dialog: null,
      requestData:{},
      rowData: [],
      approve: false
    });

    let methods = {
      // 防抖--
      debounce(instance){
        
        if(data.debounceFlag){
          clearTimeout(data.debounceFlag)
          data.debounceFlag=null
        }
        data.debounceFlag=setTimeout(()=>{
          instance.doLayout()
          console.log("表格滚动事件表格重新布局")
        },2000)

      },
      // 表格重新布局
      handleDoLayOut(){
        console.log("表格重新布局")
        data.tabel.doLayout()
      },
		
      headerClass() {
        return "headerClass";
      },
      checkColumnChange({ checked, index, row }) {
        // let obj = data.dataSource[index];
        let obj = data.dataSource.filter( i => i.Id == row.Id )

        obj.checked = checked;
        if (data.pressShiftKey) {
          let min = Math.min(data.selectFirstRowIndex, index);
          let max = Math.max(data.selectFirstRowIndex, index);

          data.dataSource.forEach((f, i) => {
            if (
              i >= min &&
              i <= max &&
              i != data.selectFirstRowIndex &&
              i != index
            ) {
              f.checked = !f.checked;
            }
          });

          data.selectFirstRowIndex = index;
        } else {
          data.selectFirstRowIndex = index;
        }

        methods.checkSelectedAll();
      },
      checkSelectedAll() {
        let selectedAllStatus = data.dataSource.every((a) => {
          return a.checked;
        });
        data.allCheckedPop = selectedAllStatus;
      },
      allCheckedChange(value) {
        let selectedAllStatus = value;
        data.dataSource.forEach((f) => {
          f.checked = selectedAllStatus;
        });
        data.allCheckedPop = value;
      },
      cellClass() {
        return "cellClass";
      },
      conditionSearch() {

        if (data.pager) {
          data.pager.search();
        } else {
            data.currentPageSinceOne=1
          methods.pageChange(1);
          
        }

        emit('searchBTN', props.condition)

        data.allCheckedPop = false;

        nextTick(() => {
          let div = data.tabelContainerDiv;
          if (div) {
            let clientHeight = div.clientHeight;

            let tabelDiv = data.tabel.$el;
            if (tabelDiv) {
              let divRowContainer = tabelDiv.querySelector(
                ".el-table__body-wrapper"
              );
              divRowContainer.style.height = `${clientHeight - 45}px`;

              divRowContainer.style.overflow = "auto";

              let tableBody = tabelDiv.querySelector(".el-table__body-wrapper");
              if (tableBody) {
                let fitWidth = props.rowTemplate.some(
                  (s) =>
                    !s.width &&
                    s.columnType != "check" &&
                    s.columnType != "index"
                );
                if (fitWidth) {
                  tableBody.style.overflowX = "hidden";
                }
              }
            }
          }
        });
      },
      pageChange(pageData, pageSize) {
        data.selectFirstRowIndex = -1;
        let conditionObj = props.condition || {};
        if (props.api) {
          // debugger
          if (props.api === "listData") {
            data.dataSource = props.apiData;
            return;
          }
          if (props.autoSearchObj) {
            let keys = Object.keys(props.autoSearchObj);
            keys.forEach((f) => {
              conditionObj[f] = props.autoSearchObj[f];
            });
          }

          if (props.showPagenation) {
            conditionObj.page = pageData;
            conditionObj.limit = pageSize ? pageSize : data.dataPagesize;
          }
          api[props.api](conditionObj).then((datas) => {
            nextTick(()=>{
               data.requestData=datas
            })
            if (datas.code == 0) {
              data.rowsCount = datas.data.count;
              let source = datas.data.list;
              source.forEach((f, index) => {
                f.checked = false;
                f.editStatus = false;
                f.customerEditStatus = false;
                f.index = index;
              });
              data.dataSource = source;
            } else {
              errMsg(datas.message);
            }
          });
        }

        if (props.showPagenation) {
          emit("update:pagenationInfo", {
            pageIndex: pageData,
            limit: data.dataPagesize,
          });
        }
      },
      sizeChange(size) {
        data.dataPagesize=size
        console.log(size, "pagesize");
        methods.pageChange(1, size);
      },
      reloadData() {
        methods.conditionSearch();
      },
      getSelection() {
        let array = [];
        data.dataSource.forEach((f) => {
          if (f.checked) {
            array.push(f);
          }
        });

        return array;
      },
      setSelection(array, appendSelection) {
        if (!appendSelection) {
          methods.allCheckedChange(false);
        }

        (array || []).forEach((f) => {
          let item = data.dataSource.find((fd) => fd[f.key] == f.value);
          if (item) {
            item.checked = true;
          }
        });
      },
      tabelCellDblClick(row) {
        if (props.editType == "row") {
          row.editStatus = true;
        }
      },
      getUpdates() {
        let array = data.dataSource.filter(
          (f) => f.editStatus === true || f.customerEditStatus === true
        );
        return array;
      },
      tableRowDblClick(row) {
        console.log('tableRowDblClick-', computeds.detailItems)
        console.log('tableRowDblClickrow-', row)
        if (row?.ToExamine == 1) {
          data.approve = true
        } else {
          data.approve = false
        }
        data.rowData = row
        // 查看rowTemplete中是否有editable
        if (!props.popToCustomer) {
          let hasEditor = props.rowTemplate.some((s) => s.editable);
          if (!hasEditor) {
            // 如果没有就返回--》没有可编辑的数据
            return;
          } 

          if (props.editType == "pop") {
            let obj=row
            if(props.popNeedTransform){
              // 此修改 公司权限 
              // obj.TypeCustomer=[]
              let TypeArray=[]
              let {TypeCustomer,TypeShooin,TypeShooinReturn,TypeService}=row
              if( TypeCustomer ) TypeArray.push(1)
              if(TypeShooin) TypeArray.push(2)
              if(TypeService) TypeArray.push(3)
              if(TypeShooinReturn) TypeArray.push(4)
              
              TypeArray=TypeArray.join(",")
              obj.TypeArray = TypeArray
            }
            data.showDialogValue = true;
            nextTick(() => {
              data.dialog.showPopDialog(obj, "修改", null, false);
            });
          }
        } else {
          emit("customerRowDblClick", row);
        }
      },
      popConfirmClick({ id, title, formPostData, slotData }) {
        emit("popConfirmButtonClick", {
          id,
          title,
          formPostData,
          slotData,
        });
      },
      popApproveClick({ id, title, formPostData, slotData }){
        emit("popConfirmButtonClick", {
          id,
          title,
          formPostData,
          slotData,
        });
      },
      closeApproveDialog({ id, title, formPostData, slotData }){
        emit("popConfirmButtonClick", {
          id,
          title,
          formPostData,
          slotData,
        });
      },
      closeDialog() {
        data.showDialogValue = false;
      },
      
      showDialog(parms, title, slotName) {
        if (slotName) {
          data.dialogSlot = slotName;
        } else {
          data.dialogSlot = null;
        }
        data.showDialogValue = true;
        nextTick(() => {
          data.dialog.showPopDialog(parms, title, slotName);
        });
      },
      rowClick(row, column, event) {
        if (props.clickRowSelected) {
          row.checked = !row.checked;

          methods.checkSelectedAll();
        }

        emit("tabelRowClick", {
          row,
          column,
          event,
        });
      },
      getData() {
        return data.dataSource;
      },
      getRequestData(reqD) {

      },
      refresh() {
        methods.reloadData();
      },
    };

    let computeds = {
      tableColumns: computed(() => {
        return props.rowTemplate.filter((f) => f.showInList !== false);
      }),
      detailItems: computed(() => {
        const res = props.rowTemplate.filter((f) => {
          return (
            f.showInDetail !== false &&
            f.columnType != "index" &&
            f.columnType != "check"
          );
        });

        return res;
      }),
      popRowTemplate: computed( ()=> {
        return data.rowData
      })
    };
    // props.apiData
    watch(
      () => {
        return props.apiData;
      },
      (newValue) => {
        // debugger
      }
    );
    watch(
      () => {
        return props.initDataSource;
      },
      (newValue) => {
        if (newValue) {
          data.dataSource = newValue;
        }
      }
    );
    watch(()=> data.requestData,newV=>{
      data.requestData=newV
      emit("getReqData",newV)
    })

    return {
      ...toRefs(data),
      ...methods,
      ...computeds,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.table-panel-containers {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  //position: relative;

  .condition-container {
    display: flex;
    width: 100%;
    height: fit-content;
    display: flex;
    align-items: center;
    align-content: center;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 30px;
    padding-bottom: 30px;
    box-sizing: border-box;
    overflow: hidden;

    .condition-search-container {
      width: fit-content;
      height: 100%;
      display: flex;
      align-items: center;
      align-content: center;
      box-sizing: border-box;

      .condition-container-button {
        margin-left: 20px;
        box-sizing: border-box;
        white-space: nowrap;
      }
    }
  }

  .tabel-panel-container {
    width: 100%;
    @include border_all("tabel-panel-border");
    border-radius: 4px;
    height: 100% !important;
    position: absolute;
    top: 0;
    left: 0;

    &:deep(.headerClass) {
      //更改---
      font-size:16px;
      height: 100%;
      width: 100%;
      @include background_color("tabel-header-bg-color");
      height: 40px;
      @include border_right("tabel-header-border-right");
      box-sizing: border-box;
      @include font_color("tabel-header-font-color");
    }

    &:deep(.cellClass) {
      text-align: center;
      font-size: 16px;
      @include font_family("font_family");
      @include font_color("tabel-row-font-color");
      height: 40px;
      @include border_bottom("tabel-row-border-bottom");
      @include border_right("tabel-row-border-right");
      
    }
  }
}
// 兼容safari
:deep(.el-table__body) {
  // 使表格兼容safari，不错位
  width: 100%;
  table-layout: fixed !important;
}
:deep(.el-table__footer) {
  // 使表格兼容safari，不错位
  width: 100%;
  table-layout: fixed !important;
}
:deep(.el-table__header) {
  // 使表格兼容safari，不错位
  width: 100%;
  table-layout: fixed !important;
}
</style>
